document.addEventListener('DOMContentLoaded', function() {
  const searchBar = document.getElementById('location-search-bar');
  const clearBtn = document.getElementById('location-clear-btn');
  fetchStoreLocationInfo('', getVariantIdFromUrl())
    
  if(searchBar && clearBtn) {
    searchBar.addEventListener('input', debounce(() => {
      clearBtn.style.display = searchBar.value ? 'block' : 'none';
      fetchStoreLocationInfo(searchBar.value, getVariantIdFromUrl());
    }, 300));

    clearBtn.addEventListener('click', () => {
      searchBar.value = '';
      clearBtn.style.display = 'none';
      searchBar.focus();
      fetchStoreLocationInfo('', getVariantIdFromUrl())
    });
  }

  document.addEventListener("modalOpened", (event) => {
    if (event.detail && event.detail.modalId === "PopupModal-storelocations") {
      const modal = document.getElementById("PopupModal-storelocations");

      if (modal) {
        const scrollContainer = modal.querySelector('.popup-modal__content-body');
        if (scrollContainer) {
          setTimeout(() => {
            scrollContainer.scrollTop = 0;
          }, 100);
        } else {
          modal.scrollTop = 0;
        }
      }
      
    }
  });
    
  document.addEventListener("modalClosed", (event) => {
    if (searchBar.value !== '' && event.detail && event.detail.modalId === "PopupModal-storelocations") {
      searchBar.value = '';
      fetchStoreLocationInfo('', getVariantIdFromUrl())
    }

    const allCards = document.querySelectorAll('.delivery-location-content');
    allCards.forEach(card => {
      card.opened = false;
      const locationInfoEl = card.querySelector('.delivery-location-info');
      const locationStoreEl = card.querySelector('.delivery-location-store');
      const locationAvailEl = card.getElementsByClassName('delivery-location-info-container');
      
      locationInfoEl.style.display = 'none';
      locationStoreEl.style.border = '1px solid #E1E3E4';
      if (locationAvailEl[0]) {
        locationAvailEl[0].style.display = 'block';
      }
    });

    
  });
})

function calculateGeodesicDistance(originLat, originLng, destinationLat, destinationLng) {
  if (originLat == null || originLng == null || destinationLat == null || destinationLng == null) {
    return null;
  }

  const EARTH_RADIUS_KM = 6371; // radius of earth in kms
  const DEG_TO_RAD = Math.PI / 180; // conversion from degrees to radians
  const deltaLat = (destinationLat - originLat) * DEG_TO_RAD;
  const deltaLng = (destinationLng - originLng) * DEG_TO_RAD;

  const a = Math.sin(deltaLat / 2) ** 2 + Math.cos(originLat * DEG_TO_RAD) * Math.cos(destinationLat * DEG_TO_RAD) * Math.sin(deltaLng / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return EARTH_RADIUS_KM * c;
}

let showPreviewImage = productImage?.preview_image?.src || secondaryImage?.[0];
function constructImage(value) {
  showPreviewImage = value?.src || showPreviewImage || productImage?.preview_image?.src;
  return showPreviewImage;
}

function getCurrentVariantValues() {
  const variantPicker = document.querySelector('variant-radios');
  if (variantPicker) {
    return productSelectedOptions.map(option => {
      const selectedVariant = variantPicker.currentVariant
      return {
        name: option.name,
        value: selectedVariant[`option${option.position}`]
      }
    });
  } else {
    return [];
  }
}

function createCardData(response) {
  const productInfoContainer = document.querySelector('.product-details-container');

  if (!productInfoContainer) return;

  const existingImageContainer = productInfoContainer.querySelector('img');
  const titleContainer = productInfoContainer.querySelector('.product-heading');
  
  const specs = productInfoContainer.querySelectorAll('.product-spec');
  specs.forEach(spec => spec.remove());

  if (existingImageContainer) {
    existingImageContainer.setAttribute('src', constructImage());
    existingImageContainer.setAttribute('height', '88');
    existingImageContainer.setAttribute('width', '88');
  } else {
    const imgContainer = document.createElement('img');
    imgContainer.setAttribute('src', constructImage());
    imgContainer.setAttribute('height', '88');
    imgContainer.setAttribute('width', '88');
    productInfoContainer.appendChild(imgContainer);
  }

  const productName = document.querySelector('.product-name').innerHTML;
  let infoContainer = titleContainer ? titleContainer.parentElement : null;

  if (!infoContainer) {
    infoContainer = document.createElement('div');
    const productTitle = document.createElement('div');
    productTitle.className = 'product-heading';
    productTitle.innerText = productName;
    infoContainer.appendChild(productTitle);
    productInfoContainer.appendChild(infoContainer);
  } else {
    titleContainer.innerText = productName;
  }

  const productSpecContainer = productInfoContainer.querySelector('.product-spec-container');
  if (productSpecContainer) {
    productSpecContainer.remove();
  }

  const variantValues = getCurrentVariantValues();
  if (variantValues && variantValues.length > 0) {
    const specContainer = document.createElement('div');
    specContainer.className = 'product-spec-container';

    variantValues.forEach(variant => {
      if (variant.value && variant.name) {
        const productSpec = document.createElement('div');
        productSpec.className = 'product-spec';

        const optionNameSpan = document.createElement('span');
        optionNameSpan.innerText = `${variant.name}: `;
  
        const optionValueSpan = document.createElement('span');
        optionValueSpan.innerText = variant.value;

        productSpec.appendChild(optionNameSpan);
        productSpec.appendChild(optionValueSpan);
        specContainer.appendChild(productSpec);
      }
    });

    if (specContainer.childElementCount > 0) {
      infoContainer.appendChild(specContainer);
    }
  }

  const container = document.querySelector('.delivery-location-container');
  container.innerHTML = '';
  const locationContentDivs = [];

  response.forEach((data, index) => {
    const locationContentDiv = document.createElement('div');
    locationContentDiv.className = 'delivery-location-content';
    locationContentDiv.id = `delivery-location-content-${index + 1}`;

    const locationStoreDiv = document.createElement('div');
    locationStoreDiv.className = 'delivery-location-store';

    const deliveryLocationInfoDiv = document.createElement('div');
    deliveryLocationInfoDiv.className = 'delivery-location-info';
    deliveryLocationInfoDiv.id = `delivery-location-info-${index + 1}`

    const deliveryLocationInfoObj = {
      'Alamat:' : data.address || '-',
      'Telpon:' : data.phone || '-',
      ...data.time && { 'Jam:': data.time }
    }

    Object.entries(deliveryLocationInfoObj).forEach(([key, value]) => {
      const deliveryLocationInfoContentDiv = document.createElement('div');
      deliveryLocationInfoContentDiv.className = 'delivery-location-info-content';

      const deliveryLocationInfoContentKeyDiv = document.createElement('div');
      deliveryLocationInfoContentKeyDiv.className = 'delivery-location-info-content-key';
      deliveryLocationInfoContentKeyDiv.innerText = key;

      const isLink = key !== 'Jam:';
      const deliveryLocationInfoContentValueDiv = document.createElement(isLink ? 'a' : 'div');
      deliveryLocationInfoContentValueDiv.className = 'delivery-location-info-content-value';
      deliveryLocationInfoContentValueDiv.innerText = value;

      if (isLink) {
        deliveryLocationInfoContentValueDiv.classList.add('redirect-link');
        let link = '';
        let isDisabled = false;  
  
        if (key === 'Telpon:') {
          link = data.phone ? `tel:${data.phone}` : 'javascript:;';
          isDisabled = !data.phone;
        } else if (key === 'Alamat:') {
          link = data.locationMapLink || 'javascript:;';
          isDisabled = !data.locationMapLink;
          deliveryLocationInfoContentValueDiv.target = '_blank';
        }
  
        deliveryLocationInfoContentValueDiv.href = link;
        deliveryLocationInfoContentValueDiv.style.color = isDisabled ? '#000' : '';
        deliveryLocationInfoContentValueDiv.style.pointerEvents = isDisabled ? 'none' : '';
      }

      deliveryLocationInfoDiv.appendChild(deliveryLocationInfoContentDiv);
      deliveryLocationInfoContentDiv.appendChild(deliveryLocationInfoContentKeyDiv);
      deliveryLocationInfoContentDiv.appendChild(deliveryLocationInfoContentValueDiv);
    });

    const locationWrapperDiv = document.createElement('div');
    locationWrapperDiv.className = 'delivery-location-wrapper';

    const locationTitleDiv = document.createElement('div');
    locationTitleDiv.className = 'delivery-location-title';
    locationTitleDiv.innerText = data.name;

    const locationAvailableDiv = document.createElement('div');
    locationAvailableDiv.className = 'delivery-location-info-container';

    const locationNameDiv = document.createElement('div');
    locationNameDiv.className = 'delivery-location-info-container__name';
    locationNameDiv.innerText = data.city + ', ' + data.province;
    locationNameDiv.style.display = 'block';

    const locationAvailableLabelDiv = document.createElement('div');
    locationAvailableLabelDiv.className = 'delivery-location-info-container__label'
    locationAvailableLabelDiv.innerText = data.stockAvailable ? 'Stok tersedia' : 'Stok habis';
    locationAvailableLabelDiv.classList.add(data.stockAvailable ? 'stock_available__label' : 'stock_unavailable__label')

    locationAvailableDiv.appendChild(locationAvailableLabelDiv);
    locationAvailableDiv.appendChild(locationNameDiv);

    const locationDescriptionDiv = document.createElement('div');
    locationDescriptionDiv.className = 'delivery-location-description'

    const locationDistanceIcon = document.createElement('span');
    locationDistanceIcon.className = 'location-distance-icon';

    const locationDistanceValue = document.createElement('span');
    locationDistanceValue.className = 'location-distance-value';

    const svgString = `
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.56423 15.0751C5.08423 15.0751 0.888672 14.5773 0.888672 12.7107C0.888672 11.8573 1.75089 11.2085 3.44867 10.7818C3.80423 10.6929 4.16867 10.9151 4.25756 11.2707C4.34645 11.6262 4.12423 11.9907 3.76867 12.0796C2.74645 12.3373 2.38201 12.604 2.25756 12.7107C2.59534 13.0573 4.35534 13.7418 7.56423 13.7418C10.7731 13.7418 12.5331 13.0662 12.8709 12.7107C12.7553 12.5951 12.3998 12.3373 11.3953 12.0885C11.0398 11.9996 10.8176 11.6351 10.9153 11.2796C11.0042 10.924 11.3687 10.7018 11.7242 10.7996C13.3953 11.2173 14.2398 11.8662 14.2398 12.7107C14.2398 14.5773 10.0442 15.0751 7.56423 15.0751ZM7.56423 1.77734C4.99534 1.77734 2.92423 3.85734 2.92423 6.41734C2.92423 9.96401 7.02201 12.7018 7.56423 12.7018C8.10645 12.7018 12.2042 9.9729 12.2042 6.41734C12.2042 3.85734 10.1242 1.77734 7.56423 1.77734ZM7.56423 8.07068C6.50645 8.07068 5.65312 7.21734 5.65312 6.15957C5.65312 5.10179 6.50645 4.24845 7.56423 4.24845C8.622 4.24845 9.47534 5.10179 9.47534 6.15957C9.47534 7.21734 8.622 8.07068 7.56423 8.07068Z" fill="#797F85"/>
    </svg>
    `;
    locationDistanceIcon.innerHTML = svgString;

    locationDistanceValue.innerText = `${data.totalDistance}km`

    locationDescriptionDiv.appendChild(locationDistanceIcon);
    locationDescriptionDiv.appendChild(locationDistanceValue);

    locationDescriptionDiv.style.display = data?.distance ? 'flex' : 'none';

    locationWrapperDiv.appendChild(locationTitleDiv);
    locationWrapperDiv.appendChild(locationNameDiv);
    locationWrapperDiv.appendChild(locationDescriptionDiv);

    locationStoreDiv.appendChild(locationWrapperDiv);
    locationStoreDiv.appendChild(locationAvailableDiv);
    locationContentDiv.appendChild(locationStoreDiv);
    locationContentDiv.appendChild(deliveryLocationInfoDiv);
    locationContentDivs.push(locationContentDiv)

    locationContentDiv.addEventListener('click', function (event) {
      if (event.target && event.target.classList.contains('redirect-link')) {
        event.stopPropagation();
        return;
      }

      const locationInfoEl = locationContentDiv.querySelector('.delivery-location-info');
      const locationStoreEl = locationContentDiv.querySelector('.delivery-location-store');
      const locationAvailEl = locationContentDiv.getElementsByClassName('delivery-location-info-container');
      const locationDescriptionEl = locationContentDiv.getElementsByClassName('delivery-location-description');
        
      // If the clicked card is already open, close it
      if (locationInfoEl.style.display === 'flex') {
        locationInfoEl.style.display = 'none';
        locationStoreEl.style.border = '1px solid #E1E3E4';

        if(locationAvailEl[0]) {
          locationAvailEl[0].style.display = 'block';
        }
        locationContentDiv.opened = false;
      } else {
        // Otherwise, close all other cards and open the clicked one
        locationContentDivs.forEach(div => {
          const otherLocationInfoEl = div.querySelector('.delivery-location-info');
          const otherLocationStoreEl = div.querySelector('.delivery-location-store');
          const otherLocationAvailEl = div.getElementsByClassName('delivery-location-info-container');

          otherLocationInfoEl.style.display = 'none';
          otherLocationStoreEl.style.border = '1px solid #E1E3E4';

          if (otherLocationAvailEl[0]) {
            otherLocationAvailEl[0].style.display = 'block';
          }
        });

        locationInfoEl.style.display = 'flex';
        locationInfoEl.style.flexDirection = 'column';
        locationInfoEl.style.gap = '8px';
        locationStoreEl.style.border = '2px solid #0071E3';
        if (data.totalDistance) {
          locationAvailEl[0].style.display = 'flex';
          locationAvailEl[0].style.flexDirection = 'row-reverse';
          locationAvailEl[0].style.justifyContent = 'space-between';
          locationDescriptionEl[0].style.display = 'flex';
        }

        locationContentDiv.opened = true; 
      }
    });

    const links = locationContentDiv.querySelectorAll('.redirect-link');
    links.forEach(link => {
      link.addEventListener('click', function(event) {
        event.stopPropagation();
      });
    });

    container.appendChild(locationContentDiv);
  })
}

async function fetchStoreLocationInfo(searchQuery = '', variantId) {
  let deviceLocation = {}
  navigator.geolocation.getCurrentPosition(
    (position) => {
      const pos = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };

      deviceLocation = pos;
      fetchStoreData(searchQuery, variantId, deviceLocation);
    },
    () => {
      fetchStoreData(searchQuery, variantId);
    },
    { timeout: 5000 }
  );
}

async function fetchStoreData(searchQuery, variantId, deviceLocation) {
  const PROD = "helloofficialstore.myshopify.com";
  const hmacKey = Shopify.shop === PROD ? "4068ab29c95a3ae364d12d33d2e62aa375bb02d7d0237f090936e64a2a8ee5b1": "5eba9ffcb69849d50d9f99b5d5998ba6e2d376bc94c54cc5e841fe917da85b62"
  try {
    const response = await fetch(`https://${env}/hello-gateway/hello-api/api/location/getLocationByVariant`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Hmac-Sha256": hmacKey,
        "X-Shopify-Shop-Domain": Shopify.shop.toString(),
      },
      body: JSON.stringify({
        searchKey: searchQuery,
        variantId: variantId
      })
    });

    if (response.status === 200) {
      const apiResponse = await response.json();
      let allStoreData = apiResponse.value.locationsList;

      allStoreData = allStoreData.map(store => {
        const distance = deviceLocation ? calculateGeodesicDistance(
          deviceLocation.latitude, deviceLocation.longitude,
          store.latitude, store.longitude) : '';
        return { ...store, distance, totalDistance: distance ? distance?.toFixed(1) : '' };
      });

      const sortedArray = allStoreData.sort((a, b) => {
        if (b.stockAvailable === a.stockAvailable) {
          // If stock availability is the same, sort by distance (Infinity is used to place stores with missing latitude/longitude at the end)
          return (a.distance ?? Infinity) - (b.distance ?? Infinity);
        }
        return b.stockAvailable - a.stockAvailable; // Sort by stockAvailable if different
      });

      createCardData(sortedArray);
    } else {
      console.error('Error fetching store locations:', response.status);
    }
  } catch (error) {
    console.error('Error fetching store locations:', error);
  }
}

function getVariantIdFromUrl() {
  const getUrl = new URLSearchParams(window.location.search);
  const selectedVariantId = getUrl.get('variant');
  return selectedVariantId ? Number(selectedVariantId) : productData.variantId;
}